export enum AppModal {
  CALENDLY = 'calendly',
  CONTACT = 'contact',
  DEMO = 'demo',
  FAHRLANDER_SETTINGS = 'fahrlanderSettings',
  KEE_VALUE_SETTINGS = 'keeValueSettings',
  HELP = 'help',
  PROJECT_AREAS = 'projectAreas',
  PROJECT_CHECKLIST = 'projectChecklist',
  PROJECT_COSTS = 'projectCosts',
  PROJECT_DETAILS = 'projectDetails',
  PROJECT_PHOTOVOLTAICS = 'projectPhotovoltaics',
  PROJECT_ENERGY_DEMAND = 'projectEnergyDemand',
  PROJECT_GEOMETRY = 'projectGeometry',
  PROJECT_INCOME = 'projectIncome',
  PROJECT_SHARE = 'projectShare',
  PROJECT_USAGE = 'projectUsage',
  PROJECT_UTILIZATION = 'projectUtilization',
  PROJECT_SETTINGS = 'projectSettings',
  SHOP = 'shop',
  SUBSCRIPTION = 'subscription',
  DATA_OVERVIEW = 'dataOverview',
}

export enum CityViewType {
  EXPLORE = 'explore',
  PROJECT = 'project',
}

export enum MapFootprintType {
  BUILDING_FOOTPRINT = 'building_footprint',
  PARKING_LOT_FOOTPRINT = 'parking_lot_footprint',
  EXISTING_BUILDING_FOOTPRINT = 'existing_building_footprint',
}

export enum SearchType {
  ADDRESS = 'address',
  PLOT_NUMBER = 'plotNumber',
}
